import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import "./App.css";

import App from "./App";
import { GlobalProvider } from "./Context/GlobalContext";
import ScrollToTop from "./Utils/ScrollToTop";
import SeoBixScript from "./Utils/SeoBixScript";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <ScrollToTop />
    <SeoBixScript />

    <GlobalProvider>
      <App />
    </GlobalProvider>
  </BrowserRouter>
);